import * as React from "react";
import { Form } from "semantic-ui-react";

import { Input } from "@neworbit/simpleui-input";

import { LinkObject, CaseType } from "@teamprevent/common/model";

import { CustomerUserCaseTypeOrgStructures } from "./models";

interface Props {
        caseTypeOrgStructure: CustomerUserCaseTypeOrgStructures;
        onCaseTypeOrgStructuresChanged: (
            caseTypeOrgStructure: CustomerUserCaseTypeOrgStructures,
            orgStructures: LinkObject[],
            includeLinkedImmunisationCases?: boolean) => void;
        isCaseTypeSelected: (caseTypeOrgStructure: CustomerUserCaseTypeOrgStructures) => boolean;
}

export const LinkedImmunisationSection: React.FunctionComponent<Props> = ({
    caseTypeOrgStructure, onCaseTypeOrgStructuresChanged, isCaseTypeSelected
}: Props) => {

    const onPpqLinkedImmunisationCasesSelectCheckboxChanged = React.useCallback((selected: boolean) => {
        return onCaseTypeOrgStructuresChanged(caseTypeOrgStructure, caseTypeOrgStructure.orgStructures, selected);
    }, [caseTypeOrgStructure, onCaseTypeOrgStructuresChanged]);

    if (caseTypeOrgStructure.value !== CaseType.PPQ
        || isCaseTypeSelected(caseTypeOrgStructure) !== true)
    {
        return null;
    }
    else
    {
        return (
            <Form.Field>
                <Input.Checkbox
                    label="Include PPQ Linked Immunisation Cases"
                    value={caseTypeOrgStructure.includeLinkedImmunisationCases}
                    onChange={onPpqLinkedImmunisationCasesSelectCheckboxChanged}
                />
            </Form.Field>
        );
    }
};
